var cache = {};

export default function deprecate(message) {
  if (process.env.NODE_ENV !== 'production' && !cache[message]) {
    console.warn(message);
    cache[message] = true;
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-plugin-lvha/es/deprecate.js
// module id = 911
// module chunks = 0